import { useContext } from 'react';
import { GuideContext, type GuideContextValue } from './guideContext';

export function useGuide(): GuideContextValue {
  const context = useContext(GuideContext);
  if (!context) {
    throw new Error('useGuide must be used inside a GuideProvider');
  }
  return context;
}
